import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ButtonProps } from '@yooga-tecnologia/mantra/loader';
import { TableService } from '../../domain/services/table.service';

/**
 * @name StatusMessageComponent
 * @description This component is used to display a FULL-WIDTH page, containing a status message to the user.
 *
 * It can be used to display a title, body, illustration, footer button and action buttons.
 */
@Component({
  selector: 'app-status-message',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './status-message.component.html',
  styleUrl: './status-message.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class StatusMessageComponent {
  @Input() title: string = '';
  @Input() body?: string | string[];
  @Input() illustration?: 'sad' | 'sadWithCoin' | 'happyCheck';
  @Input() footerButtonProps?: Partial<ButtonProps> & { onClick?: () => void };
  @Input() content?: Component;
  @Input() showActionButtons?: boolean;

  menuUrl?: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tableService: TableService,
  ) {
    this.menuUrl = this.tableService.getMenuUrl();

    this.title = this.route.snapshot.data['title'];
    this.body = this.route.snapshot.data['body'];
    this.illustration = this.route.snapshot.data['illustration'];
    this.footerButtonProps = this.route.snapshot.data['footerButtonProps'];
    this.showActionButtons = this.route.snapshot.data['showActionButtons'];
  }

  get isBodyArray(): boolean {
    return Array.isArray(this.body);
  }

  get bodyArray(): string[] {
    return this.isBodyArray ? (this.body as string[]) : [];
  }

  handleFooterButtonClick(): void {
    if (this.footerButtonProps?.onClick) {
      this.footerButtonProps.onClick();
    } else {
      this.navigateToHome();
    }
  }

  private navigateToHome(): void {
    if (this.menuUrl) {
      this.router.navigate([`/${this.menuUrl}`], { replaceUrl: true });
    } else {
      this.router.navigate(['/'], { replaceUrl: true });
    }
  }

  // TODO: Implement evaluate experience
  handleEvaluateExperience() {
    console.log('evaluate experience');
  }

  // TODO: Implement open receipt
  handleOpenReceipt() {
    console.log('open receipt');
  }
}
